'<template>
   <div class="list_right" v-loading="loading">
         <div class="right_member_info">
            <div class="member_list">
               <div class="table_content">
                  <div class="tab_row">
                     <span>活动名称</span>
                     <span>活动日期</span>
                     <span>操作记录</span>
                     <span>操作</span>
                  </div>
                  <div class="tab_row" v-for="(item,index) in list">
                     <div class="tab_title">
                        <h5>
                           <router-link :to="'/user/member/info/'+item.code">{{item.title}}</router-link>
                        </h5>
                        <p>{{item.info}}</p>
                     </div>
                     <div class="tab_times">
                        <p>{{item.startTime}} ~ {{item.endTime}}</p>
                     </div>
                     <div class="tab_times">
                        <p> {{item.isJoin == 'Y' ?'已上传资料':'无'}}</p>
                     </div>
                     <div class="tab_btns">
                        <template v-if="item.status  == 1">
                           <el-upload action="" :multiple="true" list-type="text" :file-list="fileList" :auto-upload="true" :limit="fileNum" :show-file-list="false" action="" :http-request="handleUpload" ref="sdsupload" :on-preview="handlePictureCardPreview" :on-exceed="onExceed">
                              <a href="javascript:;" class="uploud_btn" @click="listActive = index">上传资料</a>
                           </el-upload>
                        </template>
                        <a :href="item.documentFile" class="down_btn" v-if="item.isJoin == 'Y'">下载资料</a>
                     </div>
                  </div>
                  <el-empty description="暂无内容" v-if="list.length == 0"></el-empty>
               </div>
               <div class="list_pages" v-if="list.length > 0">
                  <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="pagecount" @current-change="handleCurrentChange">
                  </el-pagination>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   import {
      getCookie,
      delCookie,
      setCookie
   } from '@/assets/js/util'; // cookie操作
   export default {
      name: 'user_index_page',
      components: {},
      data() {
         return {
            loading: true,
            data: {}, //会员信息
            //活动列表
            list: [],
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,

            centerDialogVisible: false, //弹框
            listActive: 0, //选中的上传列表
            fileList: [],
            fileNum: 1, //文件上传个数
            uploadbox:'',//上传文件地址
         };
      },
      filters: {

      },
      mounted() {
         this.init();
      },
      methods: {
         init() {
            var _this = this;
            _this.$api.companyInfo({
               token: getCookie('sd_token')
            }).then(res => {
               _this.loading = false;
               _this.getlist();
               if (res.code == 200) {
                  _this.data = res.data;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         getlist() {
            var _this = this;
            _this.loading = true;
            _this.$api.activityList({
               token: getCookie('sd_token'),
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         },
         //上传文件
         onExceed(){
            this.$message.error('超出最多上传数量，最多上传1个文件！');
         },
         handleUpload(event) {
            var _this = this;
            const loading = this.$loading({
               lock: true,
               text: '上传中...',
               spinner: 'el-icon-loading',
            });
            var formData = new FormData();
            formData.append('file', event.file)
            this.$api.allupload(formData).then(res => {
               loading.close();
               if (res.code == 200) {
                  _this.uploadbox = res.url;
                  _this.uploadFile(_this.uploadbox);
                  //_this.$refs['sdsupload'].clearFiles();
               } else {
                  //_this.$refs['sdsupload'].clearFiles();
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });

         },
         handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
         },
         uploadFile(url) {
            var _this = this;
            var formData = new FormData();
            this.$api.uploadActivityFile({
               token: getCookie('sd_token'),
               documentFile:url,
               activityId:_this.list[_this.listActive].id
            }).then(res => {
               if (res.code == 200) {
                  _this.$message({
                     message: '上传成功！',
                     type: 'success'
                  });
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });

         },
      }
   }
</script>
<style lang="less" scoped>

</style>
